//#region src/bite_log_fatal_error.ts
var BiteLogFatalError = /* @__PURE__ */ function(BiteLogFatalError) {
	BiteLogFatalError[BiteLogFatalError["None"] = 0] = "None";
	BiteLogFatalError[BiteLogFatalError["ReachabilityDown"] = 21] = "ReachabilityDown";
	BiteLogFatalError[BiteLogFatalError["ScannerDisconnected"] = 22] = "ScannerDisconnected";
	BiteLogFatalError[BiteLogFatalError["ScaleDisconnected"] = 24] = "ScaleDisconnected";
	BiteLogFatalError[BiteLogFatalError["ScannerMissing"] = 25] = "ScannerMissing";
	BiteLogFatalError[BiteLogFatalError["ScaleMissing"] = 26] = "ScaleMissing";
	BiteLogFatalError[BiteLogFatalError["KitchenPrinterMissing"] = 32] = "KitchenPrinterMissing";
	BiteLogFatalError[BiteLogFatalError["KitchenPrinterDisconnected"] = 4] = "KitchenPrinterDisconnected";
	BiteLogFatalError[BiteLogFatalError["KitchenPrinterNoPaper"] = 5] = "KitchenPrinterNoPaper";
	BiteLogFatalError[BiteLogFatalError["KitchenPrinterCoverOpen"] = 6] = "KitchenPrinterCoverOpen";
	BiteLogFatalError[BiteLogFatalError["KitchenPrinterConsecutiveFailedJobs"] = 10] = "KitchenPrinterConsecutiveFailedJobs";
	BiteLogFatalError[BiteLogFatalError["ReceiptPrinterMissing"] = 31] = "ReceiptPrinterMissing";
	BiteLogFatalError[BiteLogFatalError["ReceiptPrinterDisconnected"] = 12] = "ReceiptPrinterDisconnected";
	BiteLogFatalError[BiteLogFatalError["ReceiptPrinterConsecutiveFailedJobs"] = 13] = "ReceiptPrinterConsecutiveFailedJobs";
	BiteLogFatalError[BiteLogFatalError["ReceiptPrinterNoPaper"] = 14] = "ReceiptPrinterNoPaper";
	BiteLogFatalError[BiteLogFatalError["ReceiptPrinterCoverOpen"] = 15] = "ReceiptPrinterCoverOpen";
	BiteLogFatalError[BiteLogFatalError["PaymentTerminalUpdating"] = 19] = "PaymentTerminalUpdating";
	BiteLogFatalError[BiteLogFatalError["PaymentTerminalDisconnected"] = 20] = "PaymentTerminalDisconnected";
	BiteLogFatalError[BiteLogFatalError["PaymentTerminalMissing"] = 27] = "PaymentTerminalMissing";
	BiteLogFatalError[BiteLogFatalError["PeripheralKdsDisconnected"] = 80] = "PeripheralKdsDisconnected";
	BiteLogFatalError[BiteLogFatalError["PeripheralLrsTableTrackerDisconnected"] = 81] = "PeripheralLrsTableTrackerDisconnected";
	BiteLogFatalError[BiteLogFatalError["PeripheralMsrDisconnected"] = 82] = "PeripheralMsrDisconnected";
	BiteLogFatalError[BiteLogFatalError["PeripheralTouchDisplayDisconnected"] = 83] = "PeripheralTouchDisplayDisconnected";
	BiteLogFatalError[BiteLogFatalError["MenuDataMissing"] = 50] = "MenuDataMissing";
	BiteLogFatalError[BiteLogFatalError["UsersDataMissing"] = 51] = "UsersDataMissing";
	BiteLogFatalError[BiteLogFatalError["ScriptMissing"] = 61] = "ScriptMissing";
	BiteLogFatalError[BiteLogFatalError["ImageMissing"] = 62] = "ImageMissing";
	BiteLogFatalError[BiteLogFatalError["WebViewNotReady"] = 63] = "WebViewNotReady";
	BiteLogFatalError[BiteLogFatalError["KioskError"] = 70] = "KioskError";
	BiteLogFatalError[BiteLogFatalError["Unstarted"] = 100] = "Unstarted";
	return BiteLogFatalError;
}(BiteLogFatalError || {});
//#endregion
export { BiteLogFatalError };

//# sourceMappingURL=bite_log_fatal_error.js.map